import Core from './src/core/Core';
import CdnBalancer from './src/balancer/CdnBalancer';
import Log, { LogLevel } from './src/common/log';
import NpawPluginOptions from './src/core/NpawPluginOptions';
global.LogLevel = LogLevel;
global.NpawPluginOptions = NpawPluginOptions;
export { LogLevel } from './src/common/log';
export * from './src/core/NpawPluginOptions';
export default class CdnBalancerPlugin {
    constructor(accountCode, options) {
        this.core = Core.getInstance(accountCode, options);
        this.cdnBalancer = new CdnBalancer(accountCode, options);
    }
    destroy() {
        this.core.destroy();
        this.cdnBalancer.destroy();
    }
    /**
     * Changes the log level of the NPAW Plugin. See {@link LogLevel} for the different levels available
     *
     * @param logLevel Log level to be used
     */
    setLogLevel(logLevel) {
        Log.setLogLevel(logLevel);
    }
    /**
     * Sets Balancer options. See {@link BalancerOptions}.
     * @param options Balancer options
     */
    setBalancerOptions(options) {
        this.cdnBalancer.setOptions(options);
    }
    /**
     * Sets the manifest URL of the played content in the Balancer options object.
     * For url changes the loader is restarted.
     * @param url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        this.cdnBalancer.setManifestResource(url);
    }
    /**
     * Adds an interceptor to the Balancer
     * @param name Name of the interceptor
     * @param player Video player object
     */
    addInterceptor(name, player) {
        this.cdnBalancer.addInterceptor(name, player);
    }
    /**
     * Returns Bitmovin configuration for request interception
     */
    getBitmovinSendHttpRequest() {
        return this.cdnBalancer.getBitmovinSendHttpRequest();
    }
    /**
     * Returns the manifest/video URL to be used following the Selector API.
     * If an error occurs this will return undefined
     */
    getRecommendedManifest() {
        return this.cdnBalancer.getRecommendedManifest();
    }
    /**
     * @internal
     * @returns True if balancer is enabled, false otherwise
     */
    isBalancerEnabled() {
        return this.cdnBalancer.getIsEnabled();
    }
    setLegacyPlugin(legacyPlugin) {
        Core.getInstance().setLegacyPlugin(legacyPlugin);
    }
}
